import templateUrl from 'emun.on-demand/shopping/shopping-one-up-designer.htm'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import Design from 'emun.on-demand/lib/design'
import DesignLayer from 'emun.on-demand/lib/design-layer'
import modals from 'webmodals/modals'
import orderConfig from "emun.order/order.config";

const messages = {
    cantSave: 'You will not be able to save modifications to this design until you have logged in.'
}

class OneUpDesignerController {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.messages = messages;
		$ctrl.orderConfig = orderConfig;
        $ctrl.$on('switchProduct', (e, args) => {
            args.deferred = $ctrl.switchProduct(args);
        });
    }
    initializeDesigner(designer) {
        let $ctrl = this;
        $ctrl.designer = designer;
        let designId = $ctrl.oneUp.designId;
        let productId = $ctrl.oneUp.productId;
        let position = $ctrl.oneUp.position;
        let cartItem = $ctrl.oneUp.cartItem;
        designer.ready = false;
        designer.sku = productId;
        designer.isLoading = true;
        designer.status = 'loading';

        $ctrl.$cart.$$load.then(() => {
            designer.designs = [];
            designer.areas = $ctrl.oneUp.product.areas;
            designer.productTemplateId = $ctrl.oneUp.product.productTemplateId;
            designer.label = $ctrl.oneUp.product.label;
            designer.packageId = designer.onDemandProductId = $ctrl.oneUp.product.onDemandProductId;
            ($ctrl.oneUp.product.areas || []).forEach(a => {
                if (a.copyFrom) return;
                let d = Design.fromArea(
                    a,
                    { label: $ctrl.oneUp.product.shortDescription },
                    cartItem.renderingUrl && { url: cartItem.renderingUrl },
                    cartItem.designMap && cartItem.designMap[a.euid]);
                designer.designs.push(d);
            });

            if (designer.designs.length) {
                console.warn('initializeDesigner.designId', designId);
                if (designId && designId != 'undefined') {
                    let busy = modals.busy('Retreiving...', '<hr class="hr-xl"/><div class="bigger-200 m-a-3 p-y-3">Your design is being loaded onto the selected item.</div>', 'lg');
                    designer.replaceDesign(designer.designs[0], designId).then(g => {
                        designer.activate(designer.designs[0]);
                        designer.ready = true;
                        designer.isLoading = false;
                        designer.status = 'ready';
                        busy.close();
                    });
                } else {
                    designer.activate(designer.designs[0]);
                    designer.ready = true;
                    designer.isLoading = false;
                    designer.status = 'ready';
                }
            } else {
                designer.ready = false;
                designer.isLoading = true;
                designer.status = 'no designs';
            }
            $ctrl.$pageConfig.goTop();
        });
    }

    canSave() {
        return [this.$cart.businessModel, this.$session.businessModel].indexOf('Retail') >= 0 || this.$session.isAuthenticated;
    }

    imageLoading() {
        return this.designer && this.designer.imageLoading();
    }

    getOptions(replacePredecessor) {
        const $ctrl = this;
        const designer = $ctrl.designer;
        return designer.save(replacePredecessor).then(() => {
            designer.isDirty = false;
            let compositeId = {
                fieldId: 'CompositeId',
                valueId: designer.composite.id
            };
            let compositeImageUrl = {
                fieldId: 'CompositeImageUrl',
                valueId: designer.composite.url.replace('design.json', 'hires.jpg')
            };
            let packageId = {
                fieldId: 'PackageId',
                valueId: designer.packageId
            };
            let od = {
                fieldId: 'OnDemand',
                valueId: {}
            };
            let customUrl = {
                fieldId: 'CustomUrl',
                valueId: ''
            };
            let vm = {
                fieldId: 'ValidationMessages',
                valueId: []
            };
            designer.designs.forEach(d => {
                vm.valueId = vm.valueId.concat(d.validationMessages);
                var x = od.valueId[d.areaId] = {
                    id: d.id,
                    euid: d.euid,
                    label: d.label,
                    //description: d.description,
                    width: d.width,
                    height: d.height,
                    background: d.background,
                    validationMessages: d.validationMessages,
                    url: d.url,
                    //images: d.images,
                    overlayIds: Object.keys(d.overlayImages || {}),
                    underlayIds: Object.keys(d.underlayImages || {})
                };
                var oId = x.overlayIds.concat(x.underlayIds)[0];
                if (!customUrl.valueId)
                    customUrl.valueId = d.url.replace('design.json', oId + '/hires.jpg');
            });
            od.valueId = JSON.stringify(od.valueId);
            vm.valueId = vm.valueId.join('|');
            return [packageId, compositeImageUrl, compositeId, customUrl, od, vm];
        });
    }

    switchProduct(args) {
        let $ctrl = this;
        let designer = $ctrl.designer;

        args.stateParams.designId = '';
        if (designer.isDirty) {
            designer.isDirty = false;
            return modals.dialog({
                body: `You've made modifications to this design, would you like to apply them to the selected item?`,
                title: `Keep design?`,
                size: 'md',
                buttons: {
                    'Keep Changes': {},
                    'Discard Changes': {
                        dismiss: true,
                        className: 'btn-u-default'
                    }
                }
            }).result.then(() => {
                designer.status = 'uploading';
                return designer.save(false).then(() => {
                    designer.isDirty = false;
                    args.stateParams.designId = designer.designs[0].euid;
                    return args;
                });
            }, () => args);
        } else if ($ctrl.oneUp.designId) {
            //args.stateParams.designId = $ctrl.oneUp.designId;
        }
        return args;
    }

    addCartItem() {
        let $ctrl = this;
        let designer = $ctrl.designer;
        let $cart = $ctrl.$cart;
        let item = $ctrl.oneUp.cartItem;
        let product = $ctrl.oneUp.product;
        designer.status = 'uploading';
        //var busy = modals.busy('Uploading...', 'Thank you for your patience as your design is processed.');

        //console.debug('addCartItem', product);
        return $ctrl.getOptions(false).then(productOptions => {
            designer.status = 'adding to cart';
            item.options = productOptions;

            if ($ctrl.oneUp.additionalOptions) {
                $ctrl.oneUp.additionalOptions.forEach(function (option) {
                    var newOption = {
                        fieldId: option.id,
                        valueId: option.selectedOption,
                        fieldText: option.description
                    };
                    item.options.push(newOption);
                });
            }

            //console.debug('productOptions', JSON.stringify(productOptions));
            return $cart.addItem(item, product).then(() => {
                window.history.back();
            }, () => {
                //modals.alert('Please review the validation messages.', 'Could not add item to cart');
            });
        }, (show) => {
            if (show) modals.alert('Please try again in a few moments.', 'Could not save design');
        }).then(() => designer.status = 'ready');
    }
    
    changeCartItemOptions() {
        let $ctrl = this;
        let designer = $ctrl.designer;
        let $cart = $ctrl.$cart;
        let item = $ctrl.oneUp.cartItem;
        let product = $ctrl.oneUp.product;

        designer.status = 'uploading';

        //console.debug('changeCartItemOptions', item);
        return $ctrl.getOptions(true).then(productOptions => {
            designer.status = 'modifying in cart';

            item.options = productOptions;
            if ($ctrl.oneUp.additionalOptions) {
                $ctrl.oneUp.additionalOptions.forEach(function (option) {
                    var newOption = {
                        fieldId: option.id,
                        valueId: option.selectedOption
                    };
                    item.options.push(newOption);
                });
            }
            //console.debug('productOptions', JSON.stringify(productOptions));
            return $cart.changeOptions(item, $cart.id).then(() => {
                window.history.back();
            }, () => {
                modals.alert('Please review the validation messages.', 'Could not add item to cart');
            });
        }, (show) => {
            if (show) modals.alert('Please try again in a few moments.', 'Could not save design');
        }).then(() => designer.status = 'ready');
    }

    $onInit() {
    }

    $onDestroy() {
        super.$onDestroy();
        this.designer.dispose();
        console.warn('shoppingDesigner.$onDestroy', this);
    }
}

export default {
    require: {
        oneUp: '^shoppingOneUp'
    },
    bindings: {
       // oneUp: '<oneUp',
        //designer: '<',
        //cartItem: '<?'
    },
    transclude: {
        aboveCanvas: '?aboveCanvas',
        belowCanvas: '?belowCanvas',
    },
    //scope: true,
    controller: OneUpDesignerController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
};